module.exports = __webpack_public_path__ + "static/img/15.f29ca19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/honour/15.jpg
// module id = qCen
// module chunks = 1